import { createI18n } from 'vue-i18n'

function loadLocalesData() {
  const locales = require.context('./locales', true, /\.json$/i)
  const keys = locales.keys()
  const localeData = {
    datetimeFormats: {},
    numberFormats: {},
    messages: {}
  }

  keys.forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      localeData.numberFormats[locale] = locales(key).numberFormats
      localeData.datetimeFormats[locale] = locales(key).datetimeFormats
      localeData.messages[locale] = locales(key).messages
    }
  })

  return localeData
}

const data = loadLocalesData()

function detectLocale() {
  const stored = localStorage.getItem('wander_locale')
  if (stored && data.messages[stored]) return stored

  const browserLang = (navigator.language || '').toLowerCase()
  if (browserLang.startsWith('ru')) return 'ru-RU'
  if (browserLang.startsWith('ja')) return 'ja-JP'
  if (browserLang.startsWith('en')) return 'en-US'

  return 'ru-RU'
}

export const i18n = createI18n({
  locale: detectLocale(),
  fallbackLocale: 'ru-RU',
  messages: data.messages,
  datetimeFormats: data.datetimeFormats,
  numberFormats: data.numberFormats
})

export const langs = [
  { name: 'RU', locale: 'ru-RU' },
  { name: 'EN', locale: 'en-US' },
  { name: '日本語', locale: 'ja-JP' }
]

export function setLocale(locale) {
  i18n.global.locale = locale
  localStorage.setItem('wander_locale', locale)
}
